import React from "react";
import { t } from "../../../../utils/i18n";

const CreateOfferModal = ({ statusMessage, successStatus }) => {
  return (
    <div className="createoffer-modal-cont">
      <h5>
        {successStatus ? (
          <div className="createoffer-statuscont">
            <i className="fas fa-check-circle createoffer-modal-successicon"></i>
            {" "}<span className="createoffer-modal-successtext">{t("p2p.common.success")}</span>
          </div>
        ) : (
          <div className="createoffer-statuscont">
            <i className="fas fa-times-circle createoffer-modal-failicon"></i>
            {" "}<span className="createoffer-modal-failtext">{t("p2p.create_offer_modal.fail")}</span>
          </div>
        )
      }
      </h5>
      <p className="createoffermodal-statusmessage">
        {statusMessage}
      </p>
      <div>
      {successStatus && (
        <button
          type="button"
          className="createoffer-modal-button"
          onClick={() => {
            window.location.href = "/p2p_trades/offers/search";
           }}
            >
              {t("p2p.common.okay")}
          </button>
      )}
      </div>
    </div>
  );
};

export default CreateOfferModal;
